import './App.css';
import ButtonAppBar from './components/Appbar';
import Products from './components/Products';
import { BrowserRouter, Route, Routes , Router } from 'react-router-dom';
import Product from './components/Product';
import Registration from './components/Registration';
import Home from './components/Home';
import RegistrationSuccess from './components/RegistrationSuccess';
import Login from './components/Login';
import LoginSuccess from './components/LoginSuccess';
import { AuthProvider , useAuth} from './components/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import CateringEnquiry from "./components/CateringEnquiry";
import CateringOrders from "./components/CateringOrders";
import CateringsMenu from "./components/CateringMenu";
import Employee from "./components/Employee";
import ProductMenu from "./components/ProductMenu";
import Navbar from './components/Navbar';
import PreOrderBox from './components/PreOrderBox';
import CurrySubscription from './components/CurrySubscription';
import InventoryDashboard from './components/InventoryDashboard';
import ContactUs from './components/ContactUs';
import Deliveries from "./components/Deliveries";

function Layout(){
  const { isAuthenticated } = useAuth(); // Access authentication state

  return(
   <>
    {isAuthenticated && <ButtonAppBar/>} {/* Show AppBar only after login */}
     <Routes>
       <Route path='' element={<Home></Home>} />
       <Route path='/preorderbox' element={<PreOrderBox></PreOrderBox>} />
       <Route path='/subscription' element={<CurrySubscription></CurrySubscription>} />
       <Route path='/products' element={<Products></Products>} />
       <Route path='/home' element={ <Home></Home>} />
       <Route path='/productlist' element={ <ProductMenu></ProductMenu>} />
       <Route path='/registration' element={<Registration></Registration>} />
       <Route path='/cateringsenquiry' element={<CateringEnquiry></CateringEnquiry>} />
       <Route path='/cateringOrders' element={<CateringOrders></CateringOrders>} />
       <Route path='/employee' element={<Employee></Employee>} />
       <Route path='/cateringsmenu' element={<CateringsMenu></CateringsMenu>} />
       <Route path='/registrationSuccess' element={<RegistrationSuccess></RegistrationSuccess>} />
       <Route path='/login' element={<Login></Login>} />
       <Route path='/loginSuccess' element={<LoginSuccess></LoginSuccess>} />
       <Route path='/product' element={ <ProtectedRoute> <Product></Product> </ProtectedRoute>} />
       <Route path='/contact' element={ <ContactUs></ContactUs> } />
       <Route path='/inventory' element={ <InventoryDashboard></InventoryDashboard> } />
       <Route path='/deliveries' element={<Deliveries></Deliveries>} />
     </Routes>
  </>
);

}


function AppContent() {
  const { isAuthenticated } = useAuth();

  return (
      <BrowserRouter>
        {!isAuthenticated && <Navbar />} {/* Hide Navbar when authenticated */}
        <Layout />
      </BrowserRouter>
  );
}

function App() {
  return (
      <div className="App">
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </div>
  );
}

export default App;
